module.exports = __webpack_public_path__ + "media/images/bank_images/bnb-f34489c0cbf5a0fef60c497bb3b67b1c.png";